import type {Component} from "vue";
import type {Config} from "@magnolia/vue-editor";
import Default from "~/templates/pages/Default.vue";
import HeaderSlider from "~/templates/components/HeaderSlider.vue";
import FeaturedInterview from "~/templates/components/FeaturedInterview.vue";
import PageFooter from "~/templates/components/PageFooter.vue";
import LatestArticles from "~/templates/components/LatestArticles.vue";
import Header from "~/templates/components/Header.vue";
import Image from "~/templates/components/Image.vue";
import Text from "~/templates/components/Text.vue";
import ArticleReadMore from "~/templates/components/ArticleReadMore.vue";
import ArticleOverview from "~/templates/components/ArticleOverview.vue";
import NewsletterSignup from "~/templates/components/NewsletterSignup.vue";
import FeaturedTool from "~/templates/components/FeaturedTool.vue";
import InterviewOverview from "~/templates/components/InterviewOverview.vue";
import Measurements from "~/templates/components/Measurements.vue";
import Measurement from "~/templates/components/Measurement.vue";
import MeasurementText from "~/templates/components/MeasurementText.vue";
import ContributorsOverview from "~/templates/components/ContributorsOverview.vue";
import AuthorOverview from "~/templates/components/AuthorOverview.vue";
import AnimatedSection from "~/templates/components/AnimatedSection.vue";
import LogoRibbon from "~/templates/components/LogoRibbon.vue";
import ArticleHeader from "~/templates/components/ArticleHeader.vue";
import HeaderLogo from "~/templates/components/HeaderLogo.vue";
import ContactForm from "~/templates/components/ContactForm.vue";
import Specifications from "~/templates/components/specifications.vue";
import SpecificationText from "~/templates/components/specificationText.vue";
import HeaderSlide from "~/templates/components/HeaderSlide.vue";
import PartnersOverview from "~/templates/components/PartnersOverview.vue";
import HeaderTitle from "~/templates/components/HeaderTitle.vue";
import Video from "~/templates/components/Video.vue";
import AuthorContact from "~/templates/components/AuthorContact.vue";
import IframeWindow from "~/templates/components/IframeWindow.vue";
import ToolLauncher from "~/templates/components/ToolLauncher.vue";
import LibraryOverview from "~/templates/components/LibraryOverview.vue";
import SpecialistsOverview from "~/templates/components/SpecialistsOverview.vue";

const pages: Record<string, Component> = {
  "module-dss:pages/home": Default,
  "module-dss:pages/default": Default,
  "module-dss:pages/default-light": Default,
  "module-dss:pages/article-light": Default,
  "module-dss:pages/articleOverview-light": Default,
  "module-dss:pages/authorOverview-light": Default,
  "module-dss:pages/interview-light": Default,
  "module-dss:pages/interviewOverview": Default,
  "module-dss:pages/contributorsOverview": Default,
  "module-dss:pages/partnersOverview": Default,
  "module-dss:pages/libraryOverview": Default,
  "module-dss:pages/specialistsOverview": Default,
};
const components: Record<string, Component> = {
  "module-dss:components/headerSlider": HeaderSlider,
  "module-dss:components/slide": HeaderSlide,
  "module-dss:components/header": Header,
  "module-dss:components/articleHeader": ArticleHeader,
  "module-dss:components/headerLogo": HeaderLogo,
  "module-dss:components/headerTitle": HeaderTitle,
  "module-dss:components/pageFooter": PageFooter,
  "module-dss:components/featuredInterview": FeaturedInterview,
  "module-dss:components/featuredTool": FeaturedTool,
  "module-dss:components/latestArticles": LatestArticles,
  "module-dss:components/text": Text,
  "module-dss:components/image": Image,
  "module-dss:components/video": Video,
  "module-dss:components/articleReadMore": ArticleReadMore,
  "module-dss:components/articleOverview": ArticleOverview,
  "module-dss:components/interviewOverview": InterviewOverview,
  "module-dss:components/newsletterSignup": NewsletterSignup,
  "module-dss:components/measurements": Measurements,
  "module-dss:components/measurement": Measurement,
  "module-dss:components/measurementText": MeasurementText,
  "module-dss:components/contributorsOverview": ContributorsOverview,
  "module-dss:components/authorOverview": AuthorOverview,
  "module-dss:components/animatedSection": AnimatedSection,
  "module-dss:components/logoRibbon": LogoRibbon,
  "module-dss:components/partnersOverview": PartnersOverview,
  "module-dss:components/contactForm": ContactForm,
  "module-dss:components/specifications": Specifications,
  "module-dss:components/specificationText": SpecificationText,
  "module-dss:components/authorContact": AuthorContact,
  "module-dss:components/iframe": IframeWindow,
  "module-dss:components/toolLauncher": ToolLauncher,
  "module-dss:components/libraryOverview": LibraryOverview,
  "module-dss:components/specialistsOverview": SpecialistsOverview,
};
const config: Config = {
  // TODO: Check if auto generation possible
  componentMappings: {
    ...pages,
    ...components,
  },
};

export default config;
